// Landing-page routing list. The CONTENT lives in the backend single source of
// truth (backend/services/landing_config.py) and is fetched at runtime via
// GET /api/content/landing/{slug}. This array only registers the routes, so it
// must mirror LANDING_SLUGS in the backend config.
export const LANDING_SLUGS = [
  "kentucky-saddle-pads",
  "custom-saddle-pads",
  "grooming-deluxe",
  "express-delivery",
  "spring-summer-2026",
  "kentucky-dressage",
  "kentucky-horsewear-ireland",
  "kentucky-horsewear-usa",
  "kentucky-horsewear-canada",
  "kentucky-horsewear-netherlands",
  "kentucky-horsewear-belgium",
  "kentucky-horsewear-france",
  "kentucky-horsewear-sweden",
  "kentucky-horsewear-germany",
  "grooming-deluxe-ireland",
  "grooming-deluxe-usa",
  "grooming-deluxe-canada",
  "how-to-choose-a-saddle-pad",
  "dressage-vs-jumping-saddle-pads",
  "how-to-clean-saddle-pads",
];
